"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsRecord_1 = __importDefault(require("../../typeAssertions/valueIsRecord"));
const valueIsArray_1 = __importDefault(require("../../typeAssertions/valueIsArray"));
const appStateSelectProjectId_1 = __importDefault(require("../../shared/appStateSelectProjectId"));
const callableGeoFireListenItemBuilder = ({ executeProcesses, callbacks, functionId, processor, entryVars: { itemKey, groupName }, store, }) => {
    const projectId = (0, appStateSelectProjectId_1.default)(store.getState());
    const path = groupName
        ? `projects/${projectId}/geoFireGroups/${groupName}/${itemKey}`
        : `projects/${projectId}/geoFire/${itemKey}`;
    const itemRef = processor.root.firebase.database().ref(path);
    const listener = (itemSnapshot) => {
        if (!itemSnapshot)
            return;
        const itemValue = itemSnapshot.val();
        const onNoItem = () => {
            executeProcesses(undefined, callbacks.noItem);
        };
        if (!(0, valueIsRecord_1.default)(itemValue)) {
            onNoItem();
            return;
        }
        const { l, data } = itemValue;
        if (!(0, valueIsArray_1.default)(l)) {
            onNoItem();
            return;
        }
        const [latitude, longitude] = l;
        executeProcesses(functionId, callbacks.onItemMove, { latitude, longitude, data });
    };
    itemRef.on('value', listener);
    processor.root.registerGeoFireListener({ path, listener });
};
exports.default = callableGeoFireListenItemBuilder;
